/*=========================================================================================
  File Name: moduleExpenseSettingActions.js
  Description: ExpenseSetting Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from '@/plugins/axios';

export default {
  async CreateExpenseSetting({}, credentials) {
    return new Promise((resolve, reject) => {
      // if (credentials.expense_for === 'Warehouse') {
      //     delete credentials.shop_id;
      //   } else {
      //     delete credentials.wareHouse_id;
      //   }
      axios
        .post('settings/expense-settings', credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  //   async GetExpenseSetting({ }, Id) {
  //     return new Promise((resolve, reject) => {
  //       axios
  //         .get(`settings/expense-settings/${Id}`)
  //         .then((resp) => {

  //           resolve(resp);
  //         })
  //         .catch((err) => {

  //           reject(err.response);
  //         });
  //     });
  //   },
  async GetExpenseSettingById({}, Id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`settings/expense-settings/${Id}`)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  async EditExpenseSetting({}, credentials) {
    let newId = credentials.id;
    delete credentials.Id;
    delete credentials.category;
    delete credentials.created_at;
    delete credentials.id;
    delete credentials.shop;
    delete credentials.warehouse;
    delete credentials.is_active;

    return new Promise((resolve, reject) => {
      axios
        .patch(`settings/expense-settings/${newId}`, credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  async GetExpenseSettings({}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`settings/expense-settings`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  ArchiveOrActiceExpenseSetting({}, Id) {
    return new Promise((resolve, reject) => {
      axios

        .get(`settings/expense-settings/${Id}/soft-delete`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetDocumentUploadTypes({}) {
    return new Promise((resolve, reject) => {
      axios
        .get('document-types')
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  GetDocumentTypeSearch({}, payload) {
    let url = 'document-types/search?';
    if (payload != null && payload != undefined) {
      if (payload.query != '' && payload.query != null) {
        url += `query=${payload.query}&`;
      }
      if (payload.status != '' && payload.status != null) {
        url += `status=${payload.status}`;
      }
      if (
        payload.except != undefined &&
        payload.except != null &&
        payload.except.length > 0
      ) {
        url += `except=[${payload.except}]`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetExpenseCategoriesWithChild({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('expense-categories/with-childs')
        .then((resp) => {
          commit('SET_EXPENSE_CATEGORIES_WITH_CHILS', resp.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
};
